import NavTop from '../nav-main/src/v2/nav-top';

/* istanbul ignore next */
NavTop.install = function(Vue) {
  Vue.component(NavTop.name, NavTop);
};

export default NavTop;
